import React, { useState, useEffect } from "react";
import { isInTargetWindow, isFresh } from "./functions";

interface WavesProps {
  startHour: number;
  endHour: number;
  sentDate: number;
  alreadyMade: number;
  alreadyMadeWaves: string[];
  targetFresh: number;
  minWaves: number;
  recWavesCount: number;
}

const Waves: React.FC<WavesProps> = ({
  startHour,
  endHour,
  sentDate,
  alreadyMade,
  alreadyMadeWaves,
  targetFresh,
  minWaves,
  recWavesCount
}) => {
  const [inTargetWindow, setInTargetWindow] = useState(false);
  const [fresh, setFresh] = useState(true);

  useEffect(() => {
    const checkStatus = () => {
      setFresh(isFresh(targetFresh, sentDate));
      setInTargetWindow(isInTargetWindow(startHour, endHour));
    };
    checkStatus();

    const checkStatusTimer = setInterval(() => {
      checkStatus();
    }, 60000);

    return () => clearInterval(checkStatusTimer);
  }, [sentDate]);

  return (
    <>
      {alreadyMade > 0 ? (
        <div>
          <span className="already-made__total strong">{alreadyMade}</span>
        </div>
      ) : null}
      {alreadyMadeWaves.length > 0 ? (
        <>
          {alreadyMadeWaves.map((wave: string, index: number) => (
            <span
              key={`a${index}`}
              className={`already-made__wave${
                (minWaves && minWaves > index) || recWavesCount > index
                  ? ` already-made__target${
                      minWaves && minWaves > index
                        ? " already-made__target--min-waves"
                        : ""
                    }${
                      recWavesCount > index
                        ? " already-made__target--rec-waves"
                        : ""
                    }`
                  : ""
              }`}
            >
              {wave}
            </span>
          ))}
          {minWaves
            ? Array.from({
                length: minWaves - alreadyMadeWaves.length
              }).map((_, index) => (
                <span
                  key={`b${index}`}
                  className={`already-made__wave already-made__target already-made__target--min-waves${
                    !isFresh(targetFresh, sentDate) &&
                    inTargetWindow &&
                    index === 0
                      ? " already-made__target--missing"
                      : ""
                  }`}
                >
                  &nbsp;
                </span>
              ))
            : null}
          {recWavesCount
            ? Array.from({
                length:
                  recWavesCount -
                  (minWaves > alreadyMadeWaves.length
                    ? minWaves
                    : alreadyMadeWaves.length)
              }).map((_, index) => (
                <span
                  key={`c${index}`}
                  className={`already-made__wave already-made__target already-made__target--rec-waves${
                    !isFresh(targetFresh, sentDate) &&
                    index === 0 &&
                    inTargetWindow &&
                    alreadyMadeWaves.length >= (minWaves ?? 0)
                      ? " already-made__target--missing"
                      : ""
                  }`}
                >
                  &nbsp;
                </span>
              ))
            : null}
        </>
      ) : (
        <>
          {(minWaves && minWaves > 1) || recWavesCount > 1 ? (
            <>
              {minWaves && minWaves >= 1
                ? Array.from({ length: minWaves }).map((_, index) => (
                    <>
                      <span
                        key={`d${index}`}
                        className={`already-made__wave already-made__target already-made__target--min-waves${
                          isInTargetWindow(startHour, endHour) &&
                          alreadyMade === 0 &&
                          index === 0
                            ? " already-made__target--missing"
                            : ""
                        }`}
                      >
                        &nbsp;
                      </span>
                    </>
                  ))
                : null}
              {Array.from({
                length: recWavesCount - (minWaves ?? 0)
              }).map((_, index) => (
                <>
                  <span
                    key={`e${index}`}
                    className={`already-made__wave already-made__target already-made__target--rec-waves${
                      isInTargetWindow(startHour, endHour) &&
                      (!minWaves || minWaves < 1) &&
                      alreadyMade === 0 &&
                      index === 0
                        ? " already-made__target--missing"
                        : ""
                    }`}
                  >
                    &nbsp;
                  </span>
                </>
              ))}
            </>
          ) : (
            <span
              key={sentDate}
              className={`already-made__wave${
                isInTargetWindow(startHour, endHour) && alreadyMade === 0
                  ? " already-made__target--missing"
                  : ""
              }`}
            >
              &nbsp;
            </span>
          )}
        </>
      )}
    </>
  );
};

export default Waves;
